import { Link } from "react-router-dom";
import { ShieldCheck, Clock4, AlertTriangle } from "lucide-react";

/**
 * KycPill — small "Get Verified" CTA shown in the site header for any
 * logged-in user whose KYC is not yet approved. Tap → /kyc.
 *
 * variant:
 *  - "light" (default) — for the white marketing/app Header
 *  - "dark"            — for the dark Trade-page TradeHeader
 *
 * Renders nothing for: unauthenticated users, KYC-approved users.
 */
export default function KycPill({ user, variant = "light" }) {
  if (!user || user.kyc_status === "approved") return null;

  const map = {
    pending_review: { Icon: Clock4, label: "KYC under review", tone: "amber" },
    rejected: { Icon: AlertTriangle, label: "Re-verify KYC", tone: "red" },
  };
  const { Icon, label, tone } = map[user.kyc_status] || {
    Icon: ShieldCheck,
    label: "Get Verified",
    tone: "amber",
  };

  const cls =
    variant === "dark"
      ? tone === "red"
        ? "bg-red-500/10 text-red-300 border-red-500/30 hover:bg-red-500/20"
        : "bg-amber-400/10 text-amber-300 border-amber-400/30 hover:bg-amber-400/20"
      : tone === "red"
      ? "bg-red-50 text-red-700 border-red-200 hover:bg-red-100"
      : "bg-amber-50 text-amber-800 border-amber-200 hover:bg-amber-100";

  return (
    <Link
      to="/kyc"
      data-testid="header-kyc-pill"
      className={`hidden md:inline-flex items-center gap-1.5 px-3 h-8 rounded-full border text-[12px] font-bold transition ${cls}`}
    >
      <Icon size={13} />
      {label}
    </Link>
  );
}
